var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionLogViewer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6_96",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6_96",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAADZklEQVR4nO2cTU4UQRSAP1iAJrIHVqKXEBf+ncJ4C8E74MK4YKO4IvEGLgj+3kLxAMICMTEORHfjomcCwa6aqq6qV6/b9yVv0+l59epLT3e/6Z6CfnAfeAUcAKeTOAB2gHsV6xoMN4GPwHhGvAfWKtXYe24DJ8yWPI3vwHqVSnvMdeCYcMnTOKH5FhiBfCBe8jQ+Vai3lzygu+RpqLtAztcuoIWHju1/gA1gBVgFNifbYnIYF/hK+1H6uGXfTce+X0Qq7Tkj2uUtt+y77Nj3l0ilEZQ4dVxuLmLPr9cceecCtwEsdRi3N01QaHPRNTZaxnxScDyVTVBsc9ElfnN+MVzh/GJYckxVTVDX5qIvoaYJSmku+hLVm6AczUVfIukCmXrXEdJczEVGLmLHVd0ExTQXoeQ6AruisgmKaS5CqS1aZROUe5IAh568ofEtsYbs89L4o9JrJTlUUeKIXgCe0u3IPpx8diGxhuzzSr3KuwbPefdQg+zz0njqGCQmWggTLYSJFsJEC2GihTDRQphoIUy0ECZaCBMthIkWwkQLYaKFGLLoReAZ8AM4o3nV62rVihIo8cN/DhaBPf6tayfw8+rmpa4g3JJjHrCqm5e2gnySx8DPwDza5qWqoFmSx8DzwFya5qWqoBDJe5P9QtAyL1UFLQBvPLWMgX3gSkRODfNSVVAJyXhyVSN3QfOEP9LPfbq4yGBFLwG7NG/1nwHb+AWVlIwnZzVyFbTbksMlqrRkPHmrkaOgeZojOUSYhGQ8uauRS7Tvb3JTcVKS8eSvRq6Ctj25pgKlJOMZoxq5Cgo5WqUk4xmnGjkLCrknbosu98mzGLRoiJddQjKe8apRoqBQ2aUk4xmzGqUKmiW7pGQ841ajZEEu2aUl0zLmoEVDcyexBRxNYou8dxcuss/L/sPSTvZ5DfkpuCpMtBAmWggTLYSJFsJEC2GihTDRQphoIUy0ECZaCBMthIkWwkQLkSp65NieshxbbVYd25OWY0sVfeTY/igxb01ctR+KVnGJHdqfRFxcgrgvzFoq+UW90prVz2Pfw+hr3MnkrDPvqC+hdOxns5XA/7BQ941sthJZp1mmvbaU3HEM3MroKQtrDOs08pbm26qWu8BLmvWWXcsea4wR8Jnm7qL6hc8wDMMwDMMwDEOMv4uUH+O2ceszAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionLogViewer);
export default __webpack_public_path__ + "static/media/actionLogViewer.722a888af2ed05ab0c2dc0e20d9d84bd.svg";
export { ForwardRef as ReactComponent };